export default __webpack_public_path__ + "static/media/rpl12.de587850.jpg";